import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import CursosRecomendados from "../../components/Slick/CarouselCursosRecomendados";
import { useHistory } from "react-router-dom";

import "../../static/css/trainingStyle.css";
import { Fragment } from "react";
import useMediaQuery from "../../Hooks/useMediaQuery";
import { NextArrow, PrevArrow } from "../Applicant/Conecta";
import Slider from "react-slick";

const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  arrows: true,
  centerMode: false,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

function HomeFormacion() {
  const [listTypeCourses, setlistTypeCourses] = useState([]);
  const [listModalidades, setlistModalidades] = useState([]);
  const [listNiveles, setlistNiveles] = useState([]);
  const [listSectores, setlistSectores] = useState([]);
  const [searchResult, setsearchResult] = useState([]);
  const isMobile = useMediaQuery("(max-width: 576px)");

  let history = useHistory();

  useEffect(() => {
    getTypeCourse();
    getModalidades();
    getNiveles();
    getSectores();
  }, []);

  const getTypeCourse = () => {
    axios.get("company-course/type-courses").then((result) => {
      setlistTypeCourses(result.data);
    });
  };

  const getModalidades = () => {
    axios.get("company-course/modalidad-courses").then((result) => {
      setlistModalidades(result.data);
    });
  };

  const getNiveles = () => {
    axios.get("company-course/level-courses").then((result) => {
      setlistNiveles(result.data);
    });
  };

  const getSectores = () => {
    axios.get("access/sector-list").then((result) => {
      setlistSectores(result.data);
    });
  };

  const search = (values) => {
    axios.post("access/buscar-curso", values).then((result) => {
      setsearchResult(result.data);
      if (!result.data.length > 0) {
        toast.success("No se encontraron resultados", { duration: 5000 });
      }
    });
  };

  const redirectCourse = (id) => {
    history.push("/user/DetalleCurso/" + id);
  };

  return (
    <div className="main-container">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="general-content-wrapper border-box mt-5 mb-4">
              <h5 className="box-title" style={{ textAlign: "center" }}>
                Impulsa tu conocimiento
              </h5>
              <p className="box-content mb-0" style={{ textAlign: "center" }}>
                Adquiere nuevas habilidades e impúlsate a desarrollar tu
                capacidades con los cursos y capactiaiones que ofrecen nuestros
                aliados. Mantente activo y activa en el mundo laboral, mejorando
                tu calidad de vida a través del aprendizaje, el logro de tus
                metas y persiguiento tus sueños
              </p>
            </div>

            <div className="general-content-wrapper border-box mb-5 filters">
              <h5 className="box-title" style={{ textAlign: "center" }}>
                Filtrar
              </h5>
              <Formik
                initialValues={{
                  companyId: 0,
                  formacionId: 0,
                  modalidadId: 0,
                  nivelId: 0,
                  sectorId: 0,
                  ubicacion: null,
                }}
                onSubmit={(values, { setSubmitting }) => {
                  setSubmitting(true);
                  search(values);
                  setSubmitting(false);
                }}
              >
                {({ isSubmitting }) => (
                  <Form className="row align-items-center justify-content-center mt-3">
                    <div className="col-12 col-md-6 col-xl-4 col-xxl mb-3 mb-xxl-0">
                      <Field as="select" className="form-select" name="nivelId">
                        <option hidden>Nivel</option>
                        {listNiveles.map((item) => {
                          return (
                            <option
                              key={item.nivelCourseId}
                              value={item.nivelCourseId}
                            >
                              {item.name}
                            </option>
                          );
                        })}
                      </Field>
                    </div>
                    <div className="col-12 col-md-6 col-xl-4 col-xxl mb-3 mb-xxl-0">
                      <Field
                        as="select"
                        className="form-select"
                        name="formacionId"
                      >
                        <option hidden>Formación</option>
                        {listTypeCourses.map((item) => {
                          return (
                            <option
                              key={item.formationCourseId}
                              value={item.formationCourseId}
                            >
                              {item.name}
                            </option>
                          );
                        })}
                      </Field>
                    </div>
                    <div className="col-12 col-md-6 col-xl-4 col-xxl mb-3 mb-xxl-0">
                      <Field
                        as="select"
                        className="form-select"
                        name="modalidadId"
                      >
                        <option hidden>Modalidad</option>
                        {listModalidades.map((item) => {
                          return (
                            <option
                              key={item.modalidadCourseId}
                              value={item.modalidadCourseId}
                            >
                              {item.name}
                            </option>
                          );
                        })}
                      </Field>
                    </div>
                    <div className="col-12 col-md-6 col-xl-4 col-xxl mb-3 mb-xxl-0">
                      <Field
                        as="select"
                        className="form-select"
                        name="sectorId"
                      >
                        <option hidden>Sector</option>
                        {listSectores.map((item) => {
                          return (
                            <option key={item.sectorId} value={item.sectorId}>
                              {item.name}
                            </option>
                          );
                        })}
                      </Field>
                    </div>
                    <div className="col-12 col-md-6 col-xl-4 col-xxl mb-3 mb-xxl-0">
                      <Field
                        type="text"
                        className="form-control"
                        placeholder="Ubicacion"
                        name="ubicacion"
                      ></Field>
                    </div>
                    <div className="col-12 col-md-6 col-xl-4 col-xxl mb-3 mb-xxl-0 ">
                      <input
                        className="btn btn--gradient"
                        type="submit"
                        value="Buscar"
                        disabled={isSubmitting}
                      />
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
            {!searchResult.length > 0 ? (
              <Fragment>
                <div className="general-content-wrapper border-box mb-4">
                  <h5 className="box-title" style={{ textAlign: "center" }}>
                    Recomendaciones
                  </h5>
                  <p
                    className="box-content mb-0"
                    style={{ textAlign: "center" }}
                  >
                    Según perfil de usuario
                  </p>
                  <div
                    id="carouselRecomendaciones"
                    className="carousel slide carousel-courses mt-3"
                    data-bs-ride="carousel"
                    data-bs-interval="5000"
                  >
                    <CursosRecomendados
                      id="carouselRecomendaciones"
                      qty={isMobile ? 1 : 4}
                    ></CursosRecomendados>
                  </div>
                </div>
              </Fragment>
            ) : (
              <Fragment>
                <div className="general-content-wrapper border-box mb-4">
                  <h5 className="box-title" style={{ textAlign: "center" }}>
                    Resultados de busqueda
                  </h5>
                  <div
                    id="carouselRecomendaciones"
                    className="carousel slide carousel-courses mt-3"
                    data-bs-ride="carousel"
                    data-bs-interval="5000"
                  >
                    <div className="autoplay ">
                      <Slider {...settings}>
                        {searchResult.map((item) => {
                          return (
                            <div key={item.cursoId} className="card-item">
                              <div
                                className="item__wrapper"
                                style={{
                                  width: "100%",
                                }}
                              >
                                <img
                                  src={item.foto}
                                  alt={item.nombre}
                                  onClick={() => redirectCourse(item.cursoId)}
                                  style={{
                                    cursor: "pointer",
                                    height: "11vh",
                                    width: "30%",
                                  }}
                                />
                                <div
                                  className="item__name"
                                  style={{
                                    textAlign: "center",
                                  }}
                                >
                                  {item.nombre}
                                </div>
                                <div
                                  className="item__views"
                                  style={{ textAlign: "center" }}
                                >
                                  Visualizaciones: 123
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </Slider>
                    </div>
                  </div>
                </div>
              </Fragment>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeFormacion;
